import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=44f7c79c&scoped=true&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"
import style0 from "../Style/create.scss?vue&type=style&index=0&id=44f7c79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f7c79c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f7c79c')) {
      api.createRecord('44f7c79c', component.options)
    } else {
      api.reload('44f7c79c', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=44f7c79c&scoped=true&", function () {
      api.rerender('44f7c79c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/IoFormat/Components/Create.vue"
export default component.exports